// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"050357cc","239":"9cef7c2e","453":"45895107","732":"2bce6c85"}[chunkId] + ".chunk.js";
};